import { api, setConfig } from '../..';
import { PropertyType } from '../../../common';
import { mapApiToEntity } from './mapper';

export const getMailReports = (data: PropertyType): Promise<PropertyType[]> => {
	return api.get(`/mail-reports`, setConfig(data)).then((res) => {
		return mapApiToEntity(res.data.data);
	});
};
